type Props = {
  size?: number;
  className?: string;
  title?: string;
};

/**
 * Briefcase + scales-of-justice mark. Uses currentColor so it picks up the
 * accent color from the surrounding `.shell__logo` style.
 */
export default function BriefcaseLogo({
  size = 28,
  className,
  title = "Case Filter",
}: Props) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-label={title}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      {/* Handle */}
      <path
        d="M12 9.5V8a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1.5"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      {/* Briefcase body */}
      <rect
        x="4.5"
        y="9.5"
        width="23"
        height="16.5"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      {/* Subtle divider line across the middle clasp */}
      <path
        d="M4.5 17.5h23"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        opacity="0.55"
      />
      {/* Scales of justice — pillar */}
      <path
        d="M16 13.25v8.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      {/* Scales beam */}
      <path
        d="M12 14.25h8"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      {/* Left pan (small triangle) */}
      <path
        d="M12 14.5l-1.4 2.25h2.8L12 14.5z"
        fill="currentColor"
        opacity="0.85"
      />
      {/* Right pan (small triangle) */}
      <path
        d="M20 14.5l-1.4 2.25h2.8L20 14.5z"
        fill="currentColor"
        opacity="0.85"
      />
      {/* Base */}
      <circle cx="16" cy="22.25" r="1.1" fill="currentColor" />
    </svg>
  );
}
